// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".feedback-popup-text-value[data-v-36e72b8d] {\n  font-size: 0.85rem;\n}\n.feedback-popup-text-value p[data-v-36e72b8d] {\n  opacity: 0.5;\n  word-break: break-all;\n  max-height: 80px;\n  overflow-y: auto;\n}\n.feedback-popup-text-value.status-input p[data-v-36e72b8d] {\n  opacity: 1;\n  color: var(--36e72b8d-statusColor_textColor);\n}", ""]);
// Exports
module.exports = exports;
